import { Extension } from "tiptap";
import CopyCom from "./index.vue";
import { selectAll } from "prosemirror-commands";
import { Message } from "element-ui";
import { AllSelection, TextSelection,NodeSelection } from "prosemirror-state";
export default class Upword extends Extension {
  get name() {
    return "copy";
  }
  commands() {
    return {
      deleteSelection: () => (state, dispatch) => {
        if (dispatch)
          dispatch(state.tr.setSelection(NodeSelection.create(state.doc, 0)));
        return true;
      },
      selectAll: () => selectAll
    };
  }
  menuBtnView({ isActive, commands, focus, editor }) {
    return {
      component: CopyCom,
      componentProps: {},
      componentEvents: {
        click: () => {
          // 获取编辑器内容到粘贴板
          commands.selectAll();
          document.execCommand("copy");
          commands.deleteSelection();
          Message.success("已复制");
        }
      }
    };
  }
}
